import React from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {Language} from "modules";
import {PrimaryExternalLink} from "components";
import cflLogo from "assets/images/cfl_team_picker.png";
import cflLogoFr from "assets/images/cfl_team_picker_fr.png";
import teamIcons from "assets/images/team_icons.svg";

const Wrapper = styled.div`
	width: 100%;
	background: ${({theme}) => theme.background.secondary};
	padding: 20px;

	@media (min-width: 769px) {
		padding: 30px;
	}

	@media (min-width: 900px) {
		padding: 45px;
	}
`;

const Container = styled.div`
	width: 100%;
	max-width: 1340px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const Info = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-left: 0;
	text-align: left;
	text-transform: uppercase;
	color: ${({theme}) => theme.color.tertiary};

	@media (min-width: 900px) {
		margin-right: 20px;
	}
`;

const Logo = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;

	img {
		min-width: 100px;
		width: 25vw;
	}

	.team-icons {
		margin-left: 10px;
		width: 100%;
	}

	@media (min-width: 769px) {
		display: block;

		img {
			width: 200px;
		}

		.team-icons {
			display: none;
		}
	}

	@media (min-width: 900px) {
		img {
			width: 220px;
		}
	}
`;

const Icons = styled.div`
	display: none;
	flex: 1;
	max-width: 777px;

	img {
		width: 100%;
	}

	@media (min-width: 769px) {
		display: block;
	}
`;

const Text = styled.div`
	margin: 24px 0;
	font-weight: 700;
	font-size: 24px;
	line-height: 28px;

	@media (min-width: 900px) {
		font-size: 30px;
		line-height: 34px;
	}
`;

const links: Record<string, string> = {
	en: "https://teampicker.cfl.ca/",
	fr: "https://selectionneurequipe.lcf.ca/",
};

export const TeamQuiz: React.FC = () => {
	const {t, i18n} = useTranslation();
	const lang = i18n.language;
	const logo = lang === Language.English ? cflLogo : cflLogoFr;
	const link = links[lang] || links.en;

	return (
		<Wrapper>
			<Container>
				<Info>
					<Logo>
						<div>
							<img src={logo} alt="" />
						</div>
						<div>
							<img className="team-icons" src={teamIcons} alt="" />
						</div>
					</Logo>
					<Text>
						{t("main.quiz.new_to_canadian_football")}
						<br />
						{t("main.quiz.find_team")}
					</Text>
					<PrimaryExternalLink href={link}>{t("main.quiz.link")}</PrimaryExternalLink>
				</Info>
				<Icons>
					<img src={teamIcons} alt="" />
				</Icons>
			</Container>
		</Wrapper>
	);
};
